"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { useCurrentUser } from "@/hooks/use-current-user";
import { DashboardLayout } from "@/components/layout/dashboard-layout";

export function DashboardRouteShell({
  children,
  initialSidebarCollapsed,
}: {
  children: ReactNode;
  initialSidebarCollapsed: boolean;
}) {
  const pathname = usePathname();
  const currentUserQuery = useCurrentUser();

  if (pathname === "/" && !currentUserQuery.data) {
    return children;
  }

  return (
    <DashboardLayout initialSidebarCollapsed={initialSidebarCollapsed}>
      {children}
    </DashboardLayout>
  );
}
